var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col w-full rounded-sm p-4 bg-white headerBox transition delay-75 duration-200 ease-in-out",
    },
    [
      _c("div", { staticClass: "flex justify-between items-center" }, [
        _vm.posting.job_title
          ? _c("h2", { staticClass: "jobTit text-gray-900 sm:truncate mr-4" }, [
              _vm._v(" " + _vm._s(_vm.posting.job_title) + " "),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "flex gap-2" },
          [
            _c("UiButton", {
              attrs: { variant: "outline", buttonText: "Remove", size: "lg" },
              on: {
                click: function ($event) {
                  return _vm.$emit("removePosting")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("EditIcon", { staticClass: "h-4 w-4" })]
                  },
                  proxy: true,
                },
                {
                  key: "hover-icon",
                  fn: function () {
                    return [_c("EditIcon", { staticClass: "h-6 w-6" })]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("UiButton", {
              attrs: { buttonText: "Edit", size: "lg" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.dialog = true
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function () {
                    return [_c("CompleteIcon", { staticClass: "w-4 h-4" })]
                  },
                  proxy: true,
                },
                {
                  key: "hover-icon",
                  fn: function () {
                    return [_c("CheckMarkBlack", { staticClass: "w-6 h-6" })]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "flex justify-between items-center my-4" }, [
        _c("p", { staticClass: "text-gray-new text-sm customLineH" }, [
          _vm._v(
            " Created: " +
              _vm._s(_vm._f("moment")(_vm.posting.created_at, "D MMM, YYYY")) +
              " "
          ),
        ]),
        _c(
          "div",
          { staticClass: "flex items-center" },
          [
            _c("SwitchComponent", {
              staticClass: "pr-2",
              attrs: {
                onColor: "#1890ff",
                isOn: _vm.posting.active,
                onToggle: _vm.handleToggleActiveness,
              },
            }),
            _c("span", [_vm._v(_vm._s(_vm.getActiveTitle))]),
          ],
          1
        ),
      ]),
      _c("p", { staticClass: "flex items-center mb-4" }, [
        _c(
          "svg",
          {
            staticClass: "mr-2",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z",
                stroke: "black",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
            _c("path", {
              attrs: {
                d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
                stroke: "black",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        ),
        _c("span", { staticClass: "text-gray-600 text-sm" }, [
          _vm._v(_vm._s(_vm.location)),
        ]),
      ]),
      _c("div", { staticClass: "flex items-center gap-5" }, [
        _c(
          "div",
          { staticClass: "flex flex-col gap-2" },
          [
            _c("p", { staticClass: "font-base font-normal customLineH" }, [
              _vm._v("Manager"),
            ]),
            _vm.manager
              ? _c("ItemChip", {
                  attrs: {
                    itemId: _vm.managerId,
                    itemName: _vm.manager.name,
                    avatar: _vm.manager.avatar,
                    routeName: _vm.managerRouteName,
                    isPerson: "",
                    chipClass: "bg-chip_custom_class",
                  },
                })
              : _c("p", { staticClass: "minHeigh" }, [_vm._v("n/a")]),
          ],
          1
        ),
        _c("div", { staticClass: "flex flex-col gap-2" }, [
          _c("p", { staticClass: "font-base font-normal customLineH" }, [
            _vm._v("Posted"),
          ]),
          _vm.postedAt.length
            ? _c(
                "div",
                { staticClass: "flex minHeigh" },
                _vm._l(_vm.postedAt, function (item, index) {
                  return _c("ItemChip", {
                    key: index,
                    attrs: {
                      itemId: item,
                      itemName: item,
                      chipClass: index === 1 ? "b-custom_chip_class" : "",
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "flex flex-col gap-2" }, [
          _c("p", { staticClass: "font-base font-normal customLineH" }, [
            _vm._v("Budget"),
          ]),
          _c("p", { staticClass: "budgetText minHeigh" }, [
            _vm._v(_vm._s(_vm.getBudet)),
          ]),
        ]),
      ]),
      _vm.dialog
        ? _c("PostingModal", {
            attrs: {
              data: _vm.posting,
              companyId: _vm.companyId,
              managerId: _vm.managerId,
            },
            model: {
              value: _vm.dialog,
              callback: function ($$v) {
                _vm.dialog = $$v
              },
              expression: "dialog",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }